import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'backToTop',
  setup(__props) {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        class: "back-to-top",
        onClick: scrollToTop
      }, _cache[0] || (_cache[0] = [_createElementVNode("span", {
        class: "material-symbols-outlined"
      }, " arrow_upward ", -1)]));
    };
  }
};